// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects.
// *********************************
/* tslint:disable */
import * as i from '../interfaces/index';
import { Schema } from './schema';
import { GeoPoint } from './common';
import * as e from '../enums/index';

export class Value implements i.ValueInterface {
  intValue: number;
  doubleValue: number;
  stringValue: string;
  boolValue: boolean;
  timestampValue: Date;
  listValue: ListValue;
  geopointValue: GeoPoint;

  constructor(kwargs?: i.ValueInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): Value {
    let m = new Value();
    m = Object.assign(m, proto);
    if (proto.intValue) {
      m.intValue = parseInt(proto.intValue, 10);
    }
    if (proto.timestampValue) {
      m.timestampValue = new Date(proto.timestampValue);
    }
    if (proto.listValue) {
      m.listValue = ListValue.fromProto(proto.listValue);
    }
    if (proto.geopointValue) {
      m.geopointValue = GeoPoint.fromProto(proto.geopointValue);
    }
    return m;
  }

  toApiJson(): object {
    if (
      typeof this.intValue === 'undefined' &&
      typeof this.doubleValue === 'undefined' &&
      typeof this.stringValue === 'undefined' &&
      typeof this.boolValue === 'undefined' &&
      typeof this.timestampValue === 'undefined' &&
      typeof this.listValue === 'undefined' &&
      typeof this.geopointValue === 'undefined'
    ) {
      return {};
    }

    const toReturn = {};

    if (typeof this.intValue !== 'undefined') {
      toReturn['intValue'] = this.intValue;
    }
    if (typeof this.doubleValue !== 'undefined') {
      toReturn['doubleValue'] = this.doubleValue;
    }
    if (typeof this.stringValue !== 'undefined') {
      toReturn['stringValue'] = this.stringValue;
    }
    if (typeof this.boolValue !== 'undefined') {
      toReturn['boolValue'] = this.boolValue;
    }
    if (typeof this.timestampValue !== 'undefined' && this.timestampValue !== null) {
      toReturn['timestampValue'] =
        'toApiJson' in this.timestampValue ? (this.timestampValue as any).toApiJson() : this.timestampValue;
    }
    if (typeof this.listValue !== 'undefined' && this.listValue !== null) {
      toReturn['listValue'] = 'toApiJson' in this.listValue ? (this.listValue as any).toApiJson() : this.listValue;
    }
    if (typeof this.geopointValue !== 'undefined' && this.geopointValue !== null) {
      toReturn['geopointValue'] =
        'toApiJson' in this.geopointValue ? (this.geopointValue as any).toApiJson() : this.geopointValue;
    }
    return toReturn;
  }
}

export class ListValue implements i.ListValueInterface {
  values: any[];

  constructor(kwargs?: i.ListValueInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): ListValue {
    let m = new ListValue();
    m = Object.assign(m, proto);
    return m;
  }

  toApiJson(): object {
    if (typeof this.values === 'undefined') {
      return {};
    }

    const toReturn = {};

    if (typeof this.values !== 'undefined' && this.values !== null) {
      toReturn['values'] = 'toApiJson' in this.values ? (this.values as any).toApiJson() : this.values;
    }
    return toReturn;
  }
}

export class Duration implements i.DurationInterface {
  seconds: number;
  nanos: number;

  constructor(kwargs?: i.DurationInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): Duration {
    let m = new Duration();
    m = Object.assign(m, proto);
    if (proto.seconds) {
      m.seconds = parseInt(proto.seconds, 10);
    }
    if (proto.nanos) {
      m.nanos = parseInt(proto.nanos, 10);
    }
    return m;
  }

  toApiJson(): object {
    if (typeof this.seconds === 'undefined' && typeof this.nanos === 'undefined') {
      return {};
    }

    const toReturn = {};

    if (typeof this.seconds !== 'undefined') {
      toReturn['seconds'] = this.seconds;
    }
    if (typeof this.nanos !== 'undefined') {
      toReturn['nanos'] = this.nanos;
    }
    return toReturn;
  }
}

export function enumStringToValue<E>(enumRef: any, value: string): E {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}

export class BusinessResourceId implements i.BusinessResourceIdInterface {
  businessId: string;

  constructor(kwargs?: i.BusinessResourceIdInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): BusinessResourceId {
    let m = new BusinessResourceId();
    m = Object.assign(m, proto);
    return m;
  }

  toApiJson(): object {
    if (typeof this.businessId === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}

export class GroupResourceId implements i.GroupResourceIdInterface {
  groupPathNodes: string[];

  constructor(kwargs?: i.GroupResourceIdInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): GroupResourceId {
    let m = new GroupResourceId();
    m = Object.assign(m, proto);
    return m;
  }

  toApiJson(): object {
    if (typeof this.groupPathNodes === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.groupPathNodes !== 'undefined') {
      toReturn['groupPathNodes'] = this.groupPathNodes;
    }
    return toReturn;
  }
}

export class MarketId implements i.MarketIdInterface {
  marketIds: string[];

  constructor(kwargs?: i.MarketIdInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): MarketId {
    let m = new MarketId();
    m = Object.assign(m, proto);
    return m;
  }

  toApiJson(): object {
    if (typeof this.marketIds === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    return toReturn;
  }
}

export class JWTResourceId implements i.JWTResourceIdInterface {
  jwt: string;

  constructor(kwargs?: i.JWTResourceIdInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): JWTResourceId {
    let m = new JWTResourceId();
    m = Object.assign(m, proto);
    return m;
  }

  toApiJson(): object {
    if (typeof this.jwt === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.jwt !== 'undefined') {
      toReturn['jwt'] = this.jwt;
    }
    return toReturn;
  }
}

export class SalesTeam implements i.SalesTeamInterface {
  salesTeamIds: string[];

  constructor(kwargs?: i.SalesTeamInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): SalesTeam {
    let m = new SalesTeam();
    m = Object.assign(m, proto);
    return m;
  }

  toApiJson(): object {
    if (typeof this.salesTeamIds === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.salesTeamIds !== 'undefined') {
      toReturn['salesTeamIds'] = this.salesTeamIds;
    }
    return toReturn;
  }
}

export class ResourceId implements i.ResourceIdInterface {
  groupId: GroupResourceId;
  businessId: BusinessResourceId;
  marketId: MarketId;
  jwtId: JWTResourceId;
  salesTeam: SalesTeam;

  constructor(kwargs?: i.ResourceIdInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): ResourceId {
    let m = new ResourceId();
    m = Object.assign(m, proto);
    if (proto.groupId) {
      m.groupId = GroupResourceId.fromProto(proto.groupId);
    }
    if (proto.businessId) {
      m.businessId = BusinessResourceId.fromProto(proto.businessId);
    }
    if (proto.marketId) {
      m.marketId = MarketId.fromProto(proto.marketId);
    }
    if (proto.jwtId) {
      m.jwtId = JWTResourceId.fromProto(proto.jwtId);
    }
    if (proto.salesTeam) {
      m.salesTeam = SalesTeam.fromProto(proto.salesTeam);
    }
    return m;
  }

  toApiJson(): object {
    if (
      typeof this.groupId === 'undefined' &&
      typeof this.businessId === 'undefined' &&
      typeof this.marketId === 'undefined' &&
      typeof this.jwtId === 'undefined' &&
      typeof this.salesTeam === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.groupId !== 'undefined' && this.groupId !== null) {
      toReturn['groupId'] = 'toApiJson' in this.groupId ? (this.groupId as any).toApiJson() : this.groupId;
    }
    if (typeof this.businessId !== 'undefined' && this.businessId !== null) {
      toReturn['businessId'] = 'toApiJson' in this.businessId ? (this.businessId as any).toApiJson() : this.businessId;
    }
    if (typeof this.marketId !== 'undefined' && this.marketId !== null) {
      toReturn['marketId'] = 'toApiJson' in this.marketId ? (this.marketId as any).toApiJson() : this.marketId;
    }
    if (typeof this.jwtId !== 'undefined' && this.jwtId !== null) {
      toReturn['jwtId'] = 'toApiJson' in this.jwtId ? (this.jwtId as any).toApiJson() : this.jwtId;
    }
    if (typeof this.salesTeam !== 'undefined' && this.salesTeam !== null) {
      toReturn['salesTeam'] = 'toApiJson' in this.salesTeam ? (this.salesTeam as any).toApiJson() : this.salesTeam;
    }
    return toReturn;
  }
}

export class DateRange implements i.DateRangeInterface {
  start: Date;
  end: Date;

  constructor(kwargs?: i.DateRangeInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): DateRange {
    let m = new DateRange();
    m = Object.assign(m, proto);
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    return m;
  }

  toApiJson(): object {
    if (typeof this.start === 'undefined' && typeof this.end === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? (this.start as any).toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? (this.end as any).toApiJson() : this.end;
    }
    return toReturn;
  }
}

export class SourceFilters implements i.SourceFiltersInterface {
  sourceIds: number[];

  constructor(kwargs?: i.SourceFiltersInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): SourceFilters {
    let m = new SourceFilters();
    m = Object.assign(m, proto);
    if (proto.sourceIds) {
      m.sourceIds = proto.sourceIds.map((i: any) => parseInt(i, 10));
    }
    return m;
  }

  toApiJson(): object {
    if (typeof this.sourceIds === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.sourceIds !== 'undefined') {
      toReturn['sourceIds'] = this.sourceIds;
    }
    return toReturn;
  }
}

export class Filters implements i.FiltersInterface {
  sourceFilters: SourceFilters;

  constructor(kwargs?: i.FiltersInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): Filters {
    let m = new Filters();
    m = Object.assign(m, proto);
    if (proto.sourceFilters) {
      m.sourceFilters = SourceFilters.fromProto(proto.sourceFilters);
    }
    return m;
  }

  toApiJson(): object {
    if (typeof this.sourceFilters === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.sourceFilters !== 'undefined' && this.sourceFilters !== null) {
      toReturn['sourceFilters'] =
        'toApiJson' in this.sourceFilters ? (this.sourceFilters as any).toApiJson() : this.sourceFilters;
    }
    return toReturn;
  }
}

export class GetMetricsRequest implements i.GetMetricsRequestInterface {
  metrics: e.Metric[];
  resourceIds: ResourceId[];
  partnerId: string;
  dateRange: DateRange;
  includeTimeBuckets: boolean;
  includeGroupsBusinesses: boolean;
  businessLimit: number;
  filters: Filters;

  constructor(kwargs?: i.GetMetricsRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): GetMetricsRequest {
    let m = new GetMetricsRequest();
    m = Object.assign(m, proto);
    if (proto.metrics) {
      m.metrics = proto.metrics.map((v: string) => enumStringToValue<e.Metric>(e.Metric, v));
    }
    if (proto.resourceIds) {
      m.resourceIds = proto.resourceIds.map(ResourceId.fromProto);
    }
    if (proto.dateRange) {
      m.dateRange = DateRange.fromProto(proto.dateRange);
    }
    if (proto.businessLimit) {
      m.businessLimit = parseInt(proto.businessLimit, 10);
    }
    if (proto.filters) {
      m.filters = Filters.fromProto(proto.filters);
    }
    return m;
  }

  toApiJson(): object {
    if (
      typeof this.metrics === 'undefined' &&
      typeof this.resourceIds === 'undefined' &&
      typeof this.partnerId === 'undefined' &&
      typeof this.dateRange === 'undefined' &&
      typeof this.includeTimeBuckets === 'undefined' &&
      typeof this.includeGroupsBusinesses === 'undefined' &&
      typeof this.businessLimit === 'undefined' &&
      typeof this.filters === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.metrics !== 'undefined') {
      toReturn['metrics'] = this.metrics;
    }
    if (typeof this.resourceIds !== 'undefined' && this.resourceIds !== null) {
      toReturn['resourceIds'] =
        'toApiJson' in this.resourceIds ? (this.resourceIds as any).toApiJson() : this.resourceIds;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.dateRange !== 'undefined' && this.dateRange !== null) {
      toReturn['dateRange'] = 'toApiJson' in this.dateRange ? (this.dateRange as any).toApiJson() : this.dateRange;
    }
    if (typeof this.includeTimeBuckets !== 'undefined') {
      toReturn['includeTimeBuckets'] = this.includeTimeBuckets;
    }
    if (typeof this.includeGroupsBusinesses !== 'undefined') {
      toReturn['includeGroupsBusinesses'] = this.includeGroupsBusinesses;
    }
    if (typeof this.businessLimit !== 'undefined') {
      toReturn['businessLimit'] = this.businessLimit;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? (this.filters as any).toApiJson() : this.filters;
    }
    return toReturn;
  }
}

export class ResourceMetricsResponse implements i.ResourceMetricsResponseInterface {
  value: number[];
  timeBuckets: TimeBucketMetrics[];

  constructor(kwargs?: i.ResourceMetricsResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): ResourceMetricsResponse {
    let m = new ResourceMetricsResponse();
    m = Object.assign(m, proto);
    if (proto.timeBuckets) {
      m.timeBuckets = proto.timeBuckets.map(TimeBucketMetrics.fromProto);
    }
    return m;
  }

  toApiJson(): object {
    if (typeof this.value === 'undefined' && typeof this.timeBuckets === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.timeBuckets !== 'undefined' && this.timeBuckets !== null) {
      toReturn['timeBuckets'] =
        'toApiJson' in this.timeBuckets ? (this.timeBuckets as any).toApiJson() : this.timeBuckets;
    }
    return toReturn;
  }
}

export class TimeBucketMetrics implements i.TimeBucketMetricsInterface {
  value: number[];

  constructor(kwargs?: i.TimeBucketMetricsInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): TimeBucketMetrics {
    let m = new TimeBucketMetrics();
    m = Object.assign(m, proto);
    return m;
  }

  toApiJson(): object {
    if (typeof this.value === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}

export class GetMetricsResponse implements i.GetMetricsResponseInterface {
  resourceIds: ResourceId[];
  metrics: e.Metric[];
  resourceResponses: ResourceMetricsResponse[];
  timeBucketStarts: Date[];

  constructor(kwargs?: i.GetMetricsResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): GetMetricsResponse {
    let m = new GetMetricsResponse();
    m = Object.assign(m, proto);
    if (proto.resourceIds) {
      m.resourceIds = proto.resourceIds.map(ResourceId.fromProto);
    }
    if (proto.metrics) {
      m.metrics = proto.metrics.map((v: string) => enumStringToValue<e.Metric>(e.Metric, v));
    }
    if (proto.resourceResponses) {
      m.resourceResponses = proto.resourceResponses.map(ResourceMetricsResponse.fromProto);
    }
    if (proto.timeBucketStarts) {
      m.timeBucketStarts = proto.timeBucketStarts.map((d: any) => new Date(d));
    }
    return m;
  }

  toApiJson(): object {
    if (
      typeof this.resourceIds === 'undefined' &&
      typeof this.metrics === 'undefined' &&
      typeof this.resourceResponses === 'undefined' &&
      typeof this.timeBucketStarts === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.resourceIds !== 'undefined' && this.resourceIds !== null) {
      toReturn['resourceIds'] =
        'toApiJson' in this.resourceIds ? (this.resourceIds as any).toApiJson() : this.resourceIds;
    }
    if (typeof this.metrics !== 'undefined') {
      toReturn['metrics'] = this.metrics;
    }
    if (typeof this.resourceResponses !== 'undefined' && this.resourceResponses !== null) {
      toReturn['resourceResponses'] =
        'toApiJson' in this.resourceResponses ? (this.resourceResponses as any).toApiJson() : this.resourceResponses;
    }
    if (typeof this.timeBucketStarts !== 'undefined' && this.timeBucketStarts !== null) {
      toReturn['timeBucketStarts'] =
        'toApiJson' in this.timeBucketStarts ? (this.timeBucketStarts as any).toApiJson() : this.timeBucketStarts;
    }
    return toReturn;
  }
}

export class TypedValue implements i.TypedValueInterface {
  value: Value;
  valueType: e.Type;

  constructor(kwargs?: i.TypedValueInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): TypedValue {
    let m = new TypedValue();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = Value.fromProto(proto.value);
    }
    if (proto.valueType) {
      m.valueType = enumStringToValue<e.Type>(e.Type, proto.valueType);
    }
    return m;
  }

  toApiJson(): object {
    if (typeof this.value === 'undefined' && typeof this.valueType === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? (this.value as any).toApiJson() : this.value;
    }
    if (typeof this.valueType !== 'undefined') {
      toReturn['valueType'] = this.valueType;
    }
    return toReturn;
  }
}

export class CompositeFilter implements i.CompositeFilterInterface {
  op: e.CompositeFilter_Operator;
  filters: Filter[];

  constructor(kwargs?: i.CompositeFilterInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): CompositeFilter {
    let m = new CompositeFilter();
    m = Object.assign(m, proto);
    if (proto.op) {
      m.op = enumStringToValue<e.CompositeFilter_Operator>(e.CompositeFilter_Operator, proto.op);
    }
    if (proto.filters) {
      m.filters = proto.filters.map(Filter.fromProto);
    }
    return m;
  }

  toApiJson(): object {
    if (typeof this.op === 'undefined' && typeof this.filters === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.op !== 'undefined') {
      toReturn['op'] = this.op;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? (this.filters as any).toApiJson() : this.filters;
    }
    return toReturn;
  }
}

export class FieldFilter implements i.FieldFilterInterface {
  dimension: string;
  operator: e.FieldFilter_Operator;
  operatorFunction: e.FieldFilter_OperatorFunction;
  operatorFunctionOnField: boolean;
  value: TypedValue;
  comparisonField: string;

  constructor(kwargs?: i.FieldFilterInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): FieldFilter {
    let m = new FieldFilter();
    m = Object.assign(m, proto);
    if (proto.operator) {
      m.operator = enumStringToValue<e.FieldFilter_Operator>(e.FieldFilter_Operator, proto.operator);
    }
    if (proto.operatorFunction) {
      m.operatorFunction = enumStringToValue<e.FieldFilter_OperatorFunction>(
        e.FieldFilter_OperatorFunction,
        proto.operatorFunction,
      );
    }
    if (proto.value) {
      m.value = TypedValue.fromProto(proto.value);
    }
    return m;
  }

  toApiJson(): object {
    if (
      typeof this.dimension === 'undefined' &&
      typeof this.operator === 'undefined' &&
      typeof this.operatorFunction === 'undefined' &&
      typeof this.operatorFunctionOnField === 'undefined' &&
      typeof this.value === 'undefined' &&
      typeof this.comparisonField === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.dimension !== 'undefined') {
      toReturn['dimension'] = this.dimension;
    }
    if (typeof this.operator !== 'undefined') {
      toReturn['operator'] = this.operator;
    }
    if (typeof this.operatorFunction !== 'undefined') {
      toReturn['operatorFunction'] = this.operatorFunction;
    }
    if (typeof this.operatorFunctionOnField !== 'undefined') {
      toReturn['operatorFunctionOnField'] = this.operatorFunctionOnField;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? (this.value as any).toApiJson() : this.value;
    }
    if (typeof this.comparisonField !== 'undefined') {
      toReturn['comparisonField'] = this.comparisonField;
    }
    return toReturn;
  }
}

export class UnaryFilter implements i.UnaryFilterInterface {
  op: e.UnaryFilter_Operator;
  dimension: string;

  constructor(kwargs?: i.UnaryFilterInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): UnaryFilter {
    let m = new UnaryFilter();
    m = Object.assign(m, proto);
    if (proto.op) {
      m.op = enumStringToValue<e.UnaryFilter_Operator>(e.UnaryFilter_Operator, proto.op);
    }
    return m;
  }

  toApiJson(): object {
    if (typeof this.op === 'undefined' && typeof this.dimension === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.op !== 'undefined') {
      toReturn['op'] = this.op;
    }
    if (typeof this.dimension !== 'undefined') {
      toReturn['dimension'] = this.dimension;
    }
    return toReturn;
  }
}

export class Filter implements i.FilterInterface {
  compositeFilter: CompositeFilter;
  fieldFilter: FieldFilter;
  unaryFilter: UnaryFilter;

  constructor(kwargs?: i.FilterInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): Filter {
    let m = new Filter();
    m = Object.assign(m, proto);
    if (proto.compositeFilter) {
      m.compositeFilter = CompositeFilter.fromProto(proto.compositeFilter);
    }
    if (proto.fieldFilter) {
      m.fieldFilter = FieldFilter.fromProto(proto.fieldFilter);
    }
    if (proto.unaryFilter) {
      m.unaryFilter = UnaryFilter.fromProto(proto.unaryFilter);
    }
    return m;
  }

  toApiJson(): object {
    if (
      typeof this.compositeFilter === 'undefined' &&
      typeof this.fieldFilter === 'undefined' &&
      typeof this.unaryFilter === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.compositeFilter !== 'undefined' && this.compositeFilter !== null) {
      toReturn['compositeFilter'] =
        'toApiJson' in this.compositeFilter ? (this.compositeFilter as any).toApiJson() : this.compositeFilter;
    }
    if (typeof this.fieldFilter !== 'undefined' && this.fieldFilter !== null) {
      toReturn['fieldFilter'] =
        'toApiJson' in this.fieldFilter ? (this.fieldFilter as any).toApiJson() : this.fieldFilter;
    }
    if (typeof this.unaryFilter !== 'undefined' && this.unaryFilter !== null) {
      toReturn['unaryFilter'] =
        'toApiJson' in this.unaryFilter ? (this.unaryFilter as any).toApiJson() : this.unaryFilter;
    }
    return toReturn;
  }
}

export class Aggregate implements i.AggregateInterface {
  measure: string;
  aggOp: e.Operator;
  filter: Filter;
  alias: string;

  constructor(kwargs?: i.AggregateInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): Aggregate {
    let m = new Aggregate();
    m = Object.assign(m, proto);
    if (proto.aggOp) {
      m.aggOp = enumStringToValue<e.Operator>(e.Operator, proto.aggOp);
    }
    if (proto.filter) {
      m.filter = Filter.fromProto(proto.filter);
    }
    return m;
  }

  toApiJson(): object {
    if (
      typeof this.measure === 'undefined' &&
      typeof this.aggOp === 'undefined' &&
      typeof this.filter === 'undefined' &&
      typeof this.alias === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.measure !== 'undefined') {
      toReturn['measure'] = this.measure;
    }
    if (typeof this.aggOp !== 'undefined') {
      toReturn['aggOp'] = this.aggOp;
    }
    if (typeof this.filter !== 'undefined' && this.filter !== null) {
      toReturn['filter'] = 'toApiJson' in this.filter ? (this.filter as any).toApiJson() : this.filter;
    }
    if (typeof this.alias !== 'undefined') {
      toReturn['alias'] = this.alias;
    }
    return toReturn;
  }
}

export class Measure implements i.MeasureInterface {
  measure: string;
  aggregate: Aggregate;

  constructor(kwargs?: i.MeasureInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): Measure {
    let m = new Measure();
    m = Object.assign(m, proto);
    if (proto.aggregate) {
      m.aggregate = Aggregate.fromProto(proto.aggregate);
    }
    return m;
  }

  toApiJson(): object {
    if (typeof this.measure === 'undefined' && typeof this.aggregate === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.measure !== 'undefined') {
      toReturn['measure'] = this.measure;
    }
    if (typeof this.aggregate !== 'undefined' && this.aggregate !== null) {
      toReturn['aggregate'] = 'toApiJson' in this.aggregate ? (this.aggregate as any).toApiJson() : this.aggregate;
    }
    return toReturn;
  }
}

export class AlignmentPeriod implements i.AlignmentPeriodInterface {
  duration: Duration;
  calendar: e.Calendar;

  constructor(kwargs?: i.AlignmentPeriodInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): AlignmentPeriod {
    let m = new AlignmentPeriod();
    m = Object.assign(m, proto);
    if (proto.duration) {
      m.duration = Duration.fromProto(proto.duration);
    }
    if (proto.calendar) {
      m.calendar = enumStringToValue<e.Calendar>(e.Calendar, proto.calendar);
    }
    return m;
  }

  toApiJson(): object {
    if (typeof this.duration === 'undefined' && typeof this.calendar === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.duration !== 'undefined' && this.duration !== null) {
      toReturn['duration'] = 'toApiJson' in this.duration ? (this.duration as any).toApiJson() : this.duration;
    }
    if (typeof this.calendar !== 'undefined') {
      toReturn['calendar'] = this.calendar;
    }
    return toReturn;
  }
}

export class Limit implements i.LimitInterface {
  dimension: string;
  order: e.Order;
  limit: number;

  constructor(kwargs?: i.LimitInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): Limit {
    let m = new Limit();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = enumStringToValue<e.Order>(e.Order, proto.order);
    }
    if (proto.limit) {
      m.limit = parseInt(proto.limit, 10);
    }
    return m;
  }

  toApiJson(): object {
    if (
      typeof this.dimension === 'undefined' &&
      typeof this.order === 'undefined' &&
      typeof this.limit === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.dimension !== 'undefined') {
      toReturn['dimension'] = this.dimension;
    }
    if (typeof this.order !== 'undefined') {
      toReturn['order'] = this.order;
    }
    if (typeof this.limit !== 'undefined') {
      toReturn['limit'] = this.limit;
    }
    return toReturn;
  }
}

export class Dimension implements i.DimensionInterface {
  dimension: string;
  limitDimension: Limit;

  constructor(kwargs?: i.DimensionInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): Dimension {
    let m = new Dimension();
    m = Object.assign(m, proto);
    if (proto.limitDimension) {
      m.limitDimension = Limit.fromProto(proto.limitDimension);
    }
    return m;
  }

  toApiJson(): object {
    if (typeof this.dimension === 'undefined' && typeof this.limitDimension === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.dimension !== 'undefined') {
      toReturn['dimension'] = this.dimension;
    }
    if (typeof this.limitDimension !== 'undefined' && this.limitDimension !== null) {
      toReturn['limitDimension'] =
        'toApiJson' in this.limitDimension ? (this.limitDimension as any).toApiJson() : this.limitDimension;
    }
    return toReturn;
  }
}

export class ExcludeCombination implements i.ExcludeCombinationInterface {
  dimensions: string[];

  constructor(kwargs?: i.ExcludeCombinationInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): ExcludeCombination {
    let m = new ExcludeCombination();
    m = Object.assign(m, proto);
    return m;
  }

  toApiJson(): object {
    if (typeof this.dimensions === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.dimensions !== 'undefined') {
      toReturn['dimensions'] = this.dimensions;
    }
    return toReturn;
  }
}

export class GroupBy implements i.GroupByInterface {
  dimension: Dimension[];
  groupByOperator: e.GroupBy_Operator;
  excludeCombination: ExcludeCombination[];

  constructor(kwargs?: i.GroupByInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): GroupBy {
    let m = new GroupBy();
    m = Object.assign(m, proto);
    if (proto.dimension) {
      m.dimension = proto.dimension.map(Dimension.fromProto);
    }
    if (proto.groupByOperator) {
      m.groupByOperator = enumStringToValue<e.GroupBy_Operator>(e.GroupBy_Operator, proto.groupByOperator);
    }
    if (proto.excludeCombination) {
      m.excludeCombination = proto.excludeCombination.map(ExcludeCombination.fromProto);
    }
    return m;
  }

  toApiJson(): object {
    if (
      typeof this.dimension === 'undefined' &&
      typeof this.groupByOperator === 'undefined' &&
      typeof this.excludeCombination === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.dimension !== 'undefined' && this.dimension !== null) {
      toReturn['dimension'] = 'toApiJson' in this.dimension ? (this.dimension as any).toApiJson() : this.dimension;
    }
    if (typeof this.groupByOperator !== 'undefined') {
      toReturn['groupByOperator'] = this.groupByOperator;
    }
    if (typeof this.excludeCombination !== 'undefined' && this.excludeCombination !== null) {
      toReturn['excludeCombination'] =
        'toApiJson' in this.excludeCombination ? (this.excludeCombination as any).toApiJson() : this.excludeCombination;
    }
    return toReturn;
  }
}

export class OrderColumn implements i.OrderColumnInterface {
  column: string;
  order: e.Order;

  constructor(kwargs?: i.OrderColumnInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): OrderColumn {
    let m = new OrderColumn();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = enumStringToValue<e.Order>(e.Order, proto.order);
    }
    return m;
  }

  toApiJson(): object {
    if (typeof this.column === 'undefined' && typeof this.order === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.column !== 'undefined') {
      toReturn['column'] = this.column;
    }
    if (typeof this.order !== 'undefined') {
      toReturn['order'] = this.order;
    }
    return toReturn;
  }
}

export class OrderBy implements i.OrderByInterface {
  orderBy: OrderColumn[];

  constructor(kwargs?: i.OrderByInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): OrderBy {
    let m = new OrderBy();
    m = Object.assign(m, proto);
    if (proto.orderBy) {
      m.orderBy = proto.orderBy.map(OrderColumn.fromProto);
    }
    return m;
  }

  toApiJson(): object {
    if (typeof this.orderBy === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.orderBy !== 'undefined' && this.orderBy !== null) {
      toReturn['orderBy'] = 'toApiJson' in this.orderBy ? (this.orderBy as any).toApiJson() : this.orderBy;
    }
    return toReturn;
  }
}

export class QueryMetricsRequest implements i.QueryMetricsRequestInterface {
  partnerId: string;
  metricName: string;
  resourceIds: ResourceId[];
  filter: Filter;
  measures: Measure[];
  alignmentPeriod: AlignmentPeriod;
  alignment: e.Alignment;
  groupBy: GroupBy;
  dateRange: DateRange;
  orderBy: OrderBy;
  limit: number;
  cursor: string;
  customAligner: CustomAlignerConfig;

  constructor(kwargs?: i.QueryMetricsRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): QueryMetricsRequest {
    let m = new QueryMetricsRequest();
    m = Object.assign(m, proto);
    if (proto.resourceIds) {
      m.resourceIds = proto.resourceIds.map(ResourceId.fromProto);
    }
    if (proto.filter) {
      m.filter = Filter.fromProto(proto.filter);
    }
    if (proto.measures) {
      m.measures = proto.measures.map(Measure.fromProto);
    }
    if (proto.alignmentPeriod) {
      m.alignmentPeriod = AlignmentPeriod.fromProto(proto.alignmentPeriod);
    }
    if (proto.alignment) {
      m.alignment = enumStringToValue<e.Alignment>(e.Alignment, proto.alignment);
    }
    if (proto.groupBy) {
      m.groupBy = GroupBy.fromProto(proto.groupBy);
    }
    if (proto.dateRange) {
      m.dateRange = DateRange.fromProto(proto.dateRange);
    }
    if (proto.orderBy) {
      m.orderBy = OrderBy.fromProto(proto.orderBy);
    }
    if (proto.limit) {
      m.limit = parseInt(proto.limit, 10);
    }
    if (proto.customAligner) {
      m.customAligner = CustomAlignerConfig.fromProto(proto.customAligner);
    }
    return m;
  }

  toApiJson(): object {
    if (
      typeof this.partnerId === 'undefined' &&
      typeof this.metricName === 'undefined' &&
      typeof this.resourceIds === 'undefined' &&
      typeof this.filter === 'undefined' &&
      typeof this.measures === 'undefined' &&
      typeof this.alignmentPeriod === 'undefined' &&
      typeof this.alignment === 'undefined' &&
      typeof this.groupBy === 'undefined' &&
      typeof this.dateRange === 'undefined' &&
      typeof this.orderBy === 'undefined' &&
      typeof this.limit === 'undefined' &&
      typeof this.cursor === 'undefined' &&
      typeof this.customAligner === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.metricName !== 'undefined') {
      toReturn['metricName'] = this.metricName;
    }
    if (typeof this.resourceIds !== 'undefined' && this.resourceIds !== null) {
      toReturn['resourceIds'] =
        'toApiJson' in this.resourceIds ? (this.resourceIds as any).toApiJson() : this.resourceIds;
    }
    if (typeof this.filter !== 'undefined' && this.filter !== null) {
      toReturn['filter'] = 'toApiJson' in this.filter ? (this.filter as any).toApiJson() : this.filter;
    }
    if (typeof this.measures !== 'undefined' && this.measures !== null) {
      toReturn['measures'] = 'toApiJson' in this.measures ? (this.measures as any).toApiJson() : this.measures;
    }
    if (typeof this.alignmentPeriod !== 'undefined' && this.alignmentPeriod !== null) {
      toReturn['alignmentPeriod'] =
        'toApiJson' in this.alignmentPeriod ? (this.alignmentPeriod as any).toApiJson() : this.alignmentPeriod;
    }
    if (typeof this.alignment !== 'undefined') {
      toReturn['alignment'] = this.alignment;
    }
    if (typeof this.groupBy !== 'undefined' && this.groupBy !== null) {
      toReturn['groupBy'] = 'toApiJson' in this.groupBy ? (this.groupBy as any).toApiJson() : this.groupBy;
    }
    if (typeof this.dateRange !== 'undefined' && this.dateRange !== null) {
      toReturn['dateRange'] = 'toApiJson' in this.dateRange ? (this.dateRange as any).toApiJson() : this.dateRange;
    }
    if (typeof this.orderBy !== 'undefined' && this.orderBy !== null) {
      toReturn['orderBy'] = 'toApiJson' in this.orderBy ? (this.orderBy as any).toApiJson() : this.orderBy;
    }
    if (typeof this.limit !== 'undefined') {
      toReturn['limit'] = this.limit;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.customAligner !== 'undefined' && this.customAligner !== null) {
      toReturn['customAligner'] =
        'toApiJson' in this.customAligner ? (this.customAligner as any).toApiJson() : this.customAligner;
    }
    return toReturn;
  }
}

export class MetricResult implements i.MetricResultInterface {
  dimension: any;
  measures: any[];
  results: Metrics;

  constructor(kwargs?: i.MetricResultInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): MetricResult {
    let m = new MetricResult();
    m = Object.assign(m, proto);
    if (proto.dimension) {
      m.dimension = proto.dimension;
    }
    if (proto.measures) {
      m.measures = proto.measures;
    }
    if (proto.results) {
      m.results = Metrics.fromProto(proto.results);
    }
    return m;
  }

  toApiJson(): object {
    if (
      typeof this.dimension === 'undefined' &&
      typeof this.measures === 'undefined' &&
      typeof this.results === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.dimension !== 'undefined' && this.dimension !== null) {
      toReturn['dimension'] = 'toApiJson' in this.dimension ? (this.dimension as any).toApiJson() : this.dimension;
    }
    if (typeof this.measures !== 'undefined' && this.measures !== null) {
      toReturn['measures'] = 'toApiJson' in this.measures ? (this.measures as any).toApiJson() : this.measures;
    }
    if (typeof this.results !== 'undefined' && this.results !== null) {
      toReturn['results'] = 'toApiJson' in this.results ? (this.results as any).toApiJson() : this.results;
    }
    return toReturn;
  }
}

export class Metrics implements i.MetricsInterface {
  metrics: MetricResult[];

  constructor(kwargs?: i.MetricsInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): Metrics {
    let m = new Metrics();
    m = Object.assign(m, proto);
    if (proto.metrics) {
      m.metrics = proto.metrics.map(MetricResult.fromProto);
    }
    return m;
  }

  toApiJson(): object {
    if (typeof this.metrics === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.metrics !== 'undefined' && this.metrics !== null) {
      toReturn['metrics'] = 'toApiJson' in this.metrics ? (this.metrics as any).toApiJson() : this.metrics;
    }
    return toReturn;
  }
}

export class ResourceMetricResult implements i.ResourceMetricResultInterface {
  resourceId: ResourceId;
  measuresSchema: Schema;
  dimensionsSchema: Schema;
  metrics: Metrics;
  explodedMetrics: QueryMetricsResponse;
  cursor: string;

  constructor(kwargs?: i.ResourceMetricResultInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): ResourceMetricResult {
    let m = new ResourceMetricResult();
    m = Object.assign(m, proto);
    if (proto.resourceId) {
      m.resourceId = ResourceId.fromProto(proto.resourceId);
    }
    if (proto.measuresSchema) {
      m.measuresSchema = Schema.fromProto(proto.measuresSchema);
    }
    if (proto.dimensionsSchema) {
      m.dimensionsSchema = Schema.fromProto(proto.dimensionsSchema);
    }
    if (proto.metrics) {
      m.metrics = Metrics.fromProto(proto.metrics);
    }
    if (proto.explodedMetrics) {
      m.explodedMetrics = QueryMetricsResponse.fromProto(proto.explodedMetrics);
    }
    return m;
  }

  toApiJson(): object {
    if (
      typeof this.resourceId === 'undefined' &&
      typeof this.measuresSchema === 'undefined' &&
      typeof this.dimensionsSchema === 'undefined' &&
      typeof this.metrics === 'undefined' &&
      typeof this.explodedMetrics === 'undefined' &&
      typeof this.cursor === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.resourceId !== 'undefined' && this.resourceId !== null) {
      toReturn['resourceId'] = 'toApiJson' in this.resourceId ? (this.resourceId as any).toApiJson() : this.resourceId;
    }
    if (typeof this.measuresSchema !== 'undefined' && this.measuresSchema !== null) {
      toReturn['measuresSchema'] =
        'toApiJson' in this.measuresSchema ? (this.measuresSchema as any).toApiJson() : this.measuresSchema;
    }
    if (typeof this.dimensionsSchema !== 'undefined' && this.dimensionsSchema !== null) {
      toReturn['dimensionsSchema'] =
        'toApiJson' in this.dimensionsSchema ? (this.dimensionsSchema as any).toApiJson() : this.dimensionsSchema;
    }
    if (typeof this.metrics !== 'undefined' && this.metrics !== null) {
      toReturn['metrics'] = 'toApiJson' in this.metrics ? (this.metrics as any).toApiJson() : this.metrics;
    }
    if (typeof this.explodedMetrics !== 'undefined' && this.explodedMetrics !== null) {
      toReturn['explodedMetrics'] =
        'toApiJson' in this.explodedMetrics ? (this.explodedMetrics as any).toApiJson() : this.explodedMetrics;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}

export class QueryMetricsResponse implements i.QueryMetricsResponseInterface {
  metricResults: ResourceMetricResult[];

  constructor(kwargs?: i.QueryMetricsResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): QueryMetricsResponse {
    let m = new QueryMetricsResponse();
    m = Object.assign(m, proto);
    if (proto.metricResults) {
      m.metricResults = proto.metricResults.map(ResourceMetricResult.fromProto);
    }
    return m;
  }

  toApiJson(): object {
    if (typeof this.metricResults === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.metricResults !== 'undefined' && this.metricResults !== null) {
      toReturn['metricResults'] =
        'toApiJson' in this.metricResults ? (this.metricResults as any).toApiJson() : this.metricResults;
    }
    return toReturn;
  }
}

export class CustomAlignerConfig implements i.CustomAlignerConfigInterface {
  alignmentBucketFilter: Filter;
  skipFilteringEntitiesToDateRange: boolean;

  constructor(kwargs?: i.CustomAlignerConfigInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): CustomAlignerConfig {
    let m = new CustomAlignerConfig();
    m = Object.assign(m, proto);
    if (proto.alignmentBucketFilter) {
      m.alignmentBucketFilter = Filter.fromProto(proto.alignmentBucketFilter);
    }
    return m;
  }

  toApiJson(): object {
    if (
      typeof this.alignmentBucketFilter === 'undefined' &&
      typeof this.skipFilteringEntitiesToDateRange === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.alignmentBucketFilter !== 'undefined' && this.alignmentBucketFilter !== null) {
      toReturn['alignmentBucketFilter'] =
        'toApiJson' in this.alignmentBucketFilter
          ? (this.alignmentBucketFilter as any).toApiJson()
          : this.alignmentBucketFilter;
    }
    if (typeof this.skipFilteringEntitiesToDateRange !== 'undefined') {
      toReturn['skipFilteringEntitiesToDateRange'] = this.skipFilteringEntitiesToDateRange;
    }
    return toReturn;
  }
}
